import MarkdownIt from 'markdown-it';

// Markdown completo (títulos, listas, citações, código, links...). `html: false`
// escapa HTML cru; quem exibe o resultado ainda passa por `v-dompurify-html`.
const md = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: true,
  typographer: true,
});

export function renderMarkdown(text) {
  if (!text) return '';
  return md.render(String(text));
}
